import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const campaignSettings = {
	campaign: 'Kampaň',
	startupCurve: 'Náběhová křivka',
	additionalData: 'Doplňující data',
	states: 'Stavy',
	guarantors: 'Garanti',
};

export default Object.assign({}, campaignSettings, createLabeledMessages(campaignSettings));
